/**
 * Chips dos filtros ativos de um relatório: cada um mostra "Rótulo: valor"
 * com um ✕ que limpa só aquele filtro, mais "Limpar tudo".
 *
 * A mesma lista de pares (rótulo, valor) deve alimentar o rótulo do
 * CSV/PDF — assim o que aparece na tela é o que sai no arquivo.
 * Não renderiza nada quando não há filtro ativo.
 */

export type ChipFiltro = {
  id: string;
  rotulo: string;
  valor: string;
  limpar: () => void;
};

type Props = {
  filtros: ChipFiltro[];
  onLimparTudo: () => void;
};

export function ChipsFiltros({ filtros, onLimparTudo }: Props) {
  if (filtros.length === 0) return null;
  return (
    <div className="chips-filtros" aria-label="Filtros ativos">
      <ul className="chips-filtros__lista">
        {filtros.map((f) => (
          <li key={f.id} className="chips-filtros__chip">
            <span className="chips-filtros__texto">
              <span className="chips-filtros__rotulo">{f.rotulo}:</span> {f.valor}
            </span>
            <button
              type="button"
              className="chips-filtros__remover"
              aria-label={`Remover filtro ${f.rotulo}`}
              title={`Remover filtro ${f.rotulo}`}
              onClick={f.limpar}
            >
              <span aria-hidden="true">✕</span>
            </button>
          </li>
        ))}
      </ul>
      <button type="button" className="btn btn--ghost chips-filtros__limpar" onClick={onLimparTudo}>
        Limpar tudo
      </button>
    </div>
  );
}
